// Política de fortaleza de contraseñas (TR-09). Fuente única del lado
// frontend: la regla global strong_password (main.js) y el componente
// PasswordRequirements comparten estas definiciones. El equivalente backend
// vive en visor-mapas-backend/utils/password.go (ValidatePasswordStrength);
// ambas fuentes usan clases ASCII y deben mantenerse alineadas.
export const passwordRequirements = [
  // El largo se cuenta por puntos de código Unicode ([...pw]), no por unidades
  // UTF-16 (.length), para mantener la paridad con el conteo de runas de Go
  { key: 'length', label: 'Al menos 8 caracteres', test: (pw) => [...pw].length >= 8 },
  { key: 'uppercase', label: 'Una letra mayúscula', test: (pw) => /[A-Z]/.test(pw) },
  { key: 'lowercase', label: 'Una letra minúscula', test: (pw) => /[a-z]/.test(pw) },
  { key: 'digit', label: 'Un número', test: (pw) => /[0-9]/.test(pw) },
  { key: 'symbol', label: 'Un símbolo (por ejemplo: ! # $ %)', test: (pw) => /[^A-Za-z0-9]/.test(pw) },
];

export const strongPasswordMessage = 'La contraseña no cumple los requisitos mínimos';

export function isStrongPassword(pw) {
  const value = pw || '';
  return passwordRequirements.every((req) => req.test(value));
}
